import React from 'react';
import {
  createAllProfileShareFunctions,
  getShareChannelsForProShareProfile,
} from './ProProfileShare';

/**
 * Creates a dictionary of "social share" functions
 * based on the provider's social share urls.
 *
 * Social share functions need to be created ahead of time because
 * they are only allowed to be called immediately after a user event
 * and not async
 * @param socialShareMessages
 * @param socialShareUrls
 * @param currentUser
 * @param proId
 */
export const useProProfileShareFunctions = (
  socialShareMessages,
  socialShareUrls,
  currentUser,
  proId,
) => (
  React.useMemo(() => {
    const channels = getShareChannelsForProShareProfile(socialShareUrls);
    return createAllProfileShareFunctions(channels, {
      messages: socialShareMessages,
      urls: socialShareUrls,
      currentUser,
      providerId: proId,
    });
  }, [socialShareUrls, socialShareMessages, currentUser.user_id, proId])
);
